export default "__VITE_ASSET__BaUX6tXV__"